import { render, staticRenderFns } from "./AppSliderItem.vue?vue&type=template&id=117e73f8&"
import script from "./AppSliderItem.vue?vue&type=script&lang=js&"
export * from "./AppSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./AppSliderItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports